import { FC } from "react"
import * as React from 'react'

import * as styles from './styles.module.scss';

import { Props as CardProps, ProductCard } from '../ProductCard';
import cls from 'classnames';
import Slider from "../Slider"
import { useLayout } from "src/hooks/useLayout"
import {IdHeading} from "components/organisms/IdHeading";

type heading = 1|2|3|4|5|6

type Props = {
  className?: string
  style?: Record<string, string>
  title?: string
  headingLevel?: heading

  childrenClassNames?: {
    grid?: string
    card?: {button: string, wrapper: string}
  }

  columns: number
  sliderSettings: any
  items: (CardProps & {
    gridColumn?: string
  } )[]

  sliderForPhone?: boolean
}

export const ProductsGrid: FC<Props> = ({ className, childrenClassNames, title, style ={},columns, sliderSettings,  items = [], headingLevel = 3, sliderForPhone = false}) => {
  let Component: React.ReactNode;
  const { isTablet, isPhone } = useLayout()

  if ((isTablet) || (isPhone && sliderForPhone)) {
    const settings = {
      centerMode: true,
      variableWidth: true,
      arrows: false,
      ...sliderSettings,
    }

    Component = (
        <Slider {...settings}>
          {items.map(({ style, gridColumn = '', className, slim, ...restItem }, key) => (<ProductCard headingLevel={headingLevel} className={cls(styles.card, !slim || styles.slim, className)} childrenClassNames={childrenClassNames?.card} {...restItem} key={key} style={style} />))}
        </Slider>
    )
  } else {

    Component = (
        <div className={`${styles.grid} ${childrenClassNames?.grid}`} style={{ gridTemplateRows: `repeat(${columns}, 1fr)`, ...style }}>
          {items.map(({ style, gridColumn = '', className, ...restItem }, key) => (<ProductCard headingLevel={headingLevel ? headingLevel : 3} className={cls(styles.card, className)} childrenClassNames={childrenClassNames?.card} {...restItem} key={key} style={{ ...style, gridColumn }} />))}
        </div>
    )
  }

  const wrapperClassName = isTablet ? '' : 'bs-flex-container l';

  return (
      <section className={cls(styles.container, className)}>
        <div className={wrapperClassName}>
          {title && <IdHeading headingLevel={2} className={styles.title}>{title}</IdHeading>}

          {Component}
        </div>
      </section>
  );
}

